import React from 'react';

import Footer from '../Footer';
import CoachingSessionAlertBanner from '../coaching-session/CoachingSessionAlertBanner';
import LoadingIndicator from '../common/LoadingIndicator';
import { LulNavbar } from '../navigation/LulNavbar';

import { usePageContentDataQuery } from './PageContent';

interface Props {
  isLoading?: boolean;
  showCoachingSessionAlertBanner?: boolean;
  hideFooter?: boolean;
  hideMessagesContainer?: boolean;
  hideNavBarButtons?: boolean;
}

const InboxPageContent: React.FC<React.PropsWithChildren<Props>> = ({
  children = <></>,
  isLoading = false,
  hideFooter = false,
}) => {
  const pageContentData = usePageContentDataQuery();

  return (
    // @TODO Merge shared bits with PageContent. This page required `h-screen` which cannot go on the base PageContent.
    // @NOTE: flex-col-reverse to keep the header at the top of the stack context without z-index
    <div className="flex h-screen min-h-screen flex-col-reverse overflow-hidden">
      {!hideFooter ? <Footer /> : null}
      <div className="flex grow flex-col overflow-hidden">
        {isLoading ? (
          <LoadingIndicator iconClassName="w-20 h-20" className="grow" />
        ) : (
          <>
            <CoachingSessionAlertBanner />
            {children}
          </>
        )}
      </div>
      <LulNavbar
        hideSubnav
        navCategories={pageContentData.navCategoryListings}
      />
    </div>
  );
};

export default InboxPageContent;
